import type { Command } from 'commander';
import { NullLogger } from '@gitlab-org/logging';
import { createThemeController, isGlab } from '@gitlab-org/tui';
import type { DuoCommand } from '../duo_command';
import { getInteractiveEnvInfo } from '../../utils/environment';
import type { ExitHandler } from '../../utils/exit';
import { getEnvThemeOverride } from '../../utils/theme_service';
import { getDefaultConfigurationController } from './configuration_controller';
import { renderConfig } from './configuration';

export class ConfigEditCommand implements DuoCommand {
  readonly name = 'edit';

  readonly description =
    'Edit GitLab Duo CLI configuration. Not applicable when using the CLI through `glab`.';

  readonly examples = [];

  // Under the glab distribution, `glab` manages credentials so this subcommand
  // is hidden from the help output.
  readonly hidden = isGlab();

  readonly #exitHandler: ExitHandler;

  constructor(exitHandler: ExitHandler) {
    this.#exitHandler = exitHandler;
  }

  register(node: Command): void {
    node.action(async () => {
      const configurationController = await getDefaultConfigurationController();
      const envInfo = await getInteractiveEnvInfo();
      // No DI container here, and this surface is pre-auth, so only the env-var
      // override applies — the persisted setting is stored per authenticated user.
      renderConfig(
        configurationController,
        envInfo,
        this.#exitHandler,
        new NullLogger(),
        createThemeController(getEnvThemeOverride()),
      );
    });
  }
}
